import { render, staticRenderFns } from "./date-format-editor.vue?vue&type=template&id=10c27252&scoped=true&"
import script from "./date-format-editor.vue?vue&type=script&lang=js&"
export * from "./date-format-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c27252",
  null
  
)

export default component.exports